// store/activePathSlice.js
import { createSlice } from "@reduxjs/toolkit";

const activePathSlice = createSlice({
  name: "activePath",
  initialState: "/",
  reducers: {
    setActivePath: (state, action) => action.payload,
  },
});

export const { setActivePath } = activePathSlice.actions;
export default activePathSlice.reducer;
